import { useEffect } from "react";
import { useSelector } from "react-redux";
import { fetchShiftbatsAsync } from "../features/shiftbats/shiftbatsSlice";

const useShiftbats = (auth, dispatch) => {
  const data = useSelector((state) => state.shiftbats.shiftbats);
  const status = useSelector((state) => state.shiftbats.status);
  const error = useSelector((state) => state.shiftbats.error);

  useEffect(() => {
    if (status === "idle" || (status === "fulfilled" && data === null)) {
      dispatch(fetchShiftbatsAsync(auth.getUser().id));
    }
  }, [auth, data, dispatch, status]);

  return { data, status, error };
};

export default useShiftbats;
